import { render, staticRenderFns } from "./ReportPerson.vue?vue&type=template&id=439214e1"
import script from "./ReportPerson.vue?vue&type=script&lang=js"
export * from "./ReportPerson.vue?vue&type=script&lang=js"
import style0 from "./ReportPerson.vue?vue&type=style&index=0&id=439214e1&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports